import React, { useState } from 'react';
import { Pagination } from 'antd';
import ComposeMessage from './Common/ComposeMessage';
import ConvertButtons from './Common/ConvertButtons';
import Footer from './Common/Footer';
import MessageTable from './Common/MessageTable';
import Subnav from './Common/SubNav';
import SelectList from './Common/SelectList';

const Message = (props) => {
    const messageTable = [
        {
            name: 'Admin s',
            subject: 'Measurement',
            desc: 'check  members measurement',
            date: 'march 14 2021'
        },
        {
            name: 'Admin c',
            subject: 'Measurement all',
            desc: 'check all members measurement',
            date: 'april 10 2022'
        },
        {
            name: 'Admin t',
            subject: 'Partial fullfillment',
            desc: 'check all members partial fullfillment',
            date: 'january 09 2022'
        },
        {
            name: 'Admin v',
            subject: 'fullfillment',
            desc: 'check all members fullfillment',
            date: 'may 07 2022'
        }
    ];

    const [data, setData] = useState(messageTable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [isInbox, setIsInbox] = useState(true);
    const [isSent, setIsSent] = useState(false);
    const [isCompose, setIsCompose] = useState(false);
    const dataRef = React.createRef();
    const { isShow, setIsShow } = props;

    const handleInClick = () => {
        setIsInbox(true)
        setIsSent(false)
    };

    const handleSentClick = () => {
        setIsInbox(false)
        setIsSent(true)
    };

    const handleCompose = () => {
        setIsCompose(false)
    }

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <>
            <div className='page_first_div'>
                <Subnav isShow={isShow} setIsShow={setIsShow} />
                <div className='page_sec_div'>
                    <p className='page_topic'>
                        <i className="fa-solid fa-plus mr-2 text-3xl font-extrabold font-sans"></i>{isInbox ? "Inbox Messages" : "Sent Messages"}
                    </p>
                    <section className='page_section min-h-[23rem] '>
                        <div className='flex flex-col items-center xl:items-start justify-center px-4 gap-4 xl:gap-8 xl:flex-row pt-8 '>

                            {/* messages length and compose button */}
                            <div className=' w-full  lg:w-1/3 xl:w-1/5  text-center'>
                                <button className=' w-3/4 xsm:w-1/2 sm:w-2/5 lg:w-full xl:text-base text-sm py-2 mb-4 text-white  animation hover:bg-[#34a874] rounded-sm bg-[#30c381]' onClick={() => setIsCompose(true)}>Compose</button>
                                <div className='border-b-2 flex justify-between items-center w-3/4 xsm:w-1/2 sm:w-2/5 lg:w-full mx-auto'>
                                    <a href="#" className='text-gray-500 leading-8' onClick={handleInClick}>
                                        <i className="fa-solid fa-inbox"></i>
                                        <span className='ml-2 text-sm sm:text-base'>Inbox</span>
                                    </a>
                                    <div className='bg-[#33ab75] h-6 w-6 rounded-full text-white text-sm leading-6'>{messageTable.length}</div>
                                </div>
                                <div className='border-b-2 flex justify-between items-center w-3/4 xsm:w-1/2 sm:w-2/5 lg:w-full mx-auto'>
                                    <a href="#" className='text-gray-500 leading-10' onClick={handleSentClick}>
                                        <i className="fa-solid fa-arrow-right-from-bracket"></i>
                                        <span className='ml-2 text-sm sm:text-base'>Sent</span>
                                    </a>
                                    <div className='bg-[#33ab75] h-6 w-6 rounded-full text-white text-sm leading-6'>{messageTable.length}</div>
                                </div>
                            </div>

                            {/* showing Message type and convert buttons */}
                            <div className='w-full lg:px-8 '>
                                <div className='flex flex-col md:flex-row justify-between items-center'>
                                    <p className='text-gray-600 text-center pb-4 lg:text-left text-xl sm:text-2xl font-medium'>{`${isSent ? "Sent Messages" : "Inbox Messages"}`}</p>
                                    <ConvertButtons
                                        data={data}
                                        ref={dataRef}
                                    />
                                </div>

                                {/* message Table */}
                                <MessageTable
                                    data={currentPost}
                                    sortData={data}
                                    setData={setData}
                                    ref={dataRef}
                                />
                                <div className='flex justify-between items-center'>
                                    <p>Showing {page} to {currentPost.length} of {data.length} messages</p>
                                    <Pagination
                                        total={data.length}
                                        itemRender={itemRender}
                                        onChange={value => setPage(value)}
                                        pageSize={postPerPage}
                                        current={page}
                                    />
                                </div>

                            </div>

                        </div>
                    </section>
                </div>

                {/* on button click showing compose option */}
                <ComposeMessage isCompose={isCompose} setIsCompose={setIsCompose} handleCompose={handleCompose} />
                <Footer />
            </div>
        </>
    )
}

export default Message;